import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import { Loader } from '@/shared';

import { getSubscriptions } from '../actions';

const SubscriptionsAsync = dynamic(() =>
	import('./subscriptions').then((mod) => mod.Subscriptions),
);

type SubscriptionsLazyProps = {
	children: (props: React.PropsWithChildren) => React.ReactNode;
	isPromoCodeValid?: boolean;
	promocode?: string;
};

export function SubscriptionsLazy({
	children,
	isPromoCodeValid,
	promocode,
}: SubscriptionsLazyProps) {
	const data = getSubscriptions();
	return (
		<Suspense fallback={<Loader />}>
			<SubscriptionsAsync
				data={data}
				isPromoCodeValid={isPromoCodeValid}
				promocode={promocode}
			>
				{children}
			</SubscriptionsAsync>
		</Suspense>
	);
}
